import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 11.5L4 6C4 3.79086 5.79086 2 8 2H16C18.2091 2 20 3.79086 20 6V17C20 19.2091 18.2091 21 16 21V21",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 6.5H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 9.5H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.3335 13V21.6667",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6665 17.3333L3.99984 17.3333",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgAddReport;
